import { EmojiData } from '@/types/meme.interface'

// Default 6 quick reactions for community
export const communityDefaultReactions: Record<
  string,
  {
    activeColor: string
    hoverBgColor: string
    hoverShadow: string
    activeBgColor: string
    hoverColor: string
    emoji: string
    name: string
  }
> = {
  like: {
    activeColor: 'text-blue-600',
    hoverBgColor: '#eff6ff',
    hoverShadow: '0 0 12px rgba(37, 99, 235, 0.6)',
    activeBgColor: '#dbeafe',
    hoverColor: '#2563eb',
    emoji: '👍',
    name: 'Like',
  },
  love: {
    activeColor: 'text-pink-600',
    hoverBgColor: '#fdf2f8',
    hoverShadow: '0 0 12px rgba(219, 39, 119, 0.6)',
    activeBgColor: '#fce7f3',
    hoverColor: '#db2777',
    emoji: '❤️',
    name: 'Love',
  },
  haha: {
    activeColor: 'text-yellow-600',
    hoverBgColor: '#fefce8',
    hoverShadow: '0 0 12px rgba(217, 119, 6, 0.6)',
    hoverColor: '#ca8a04',
    activeBgColor: '#fef9c3',
    emoji: '😂',
    name: 'Haha',
  },
  wow: {
    activeColor: 'text-yellow-500',
    hoverBgColor: '#fffbeb',
    hoverShadow: '0 0 12px rgba(245, 158, 11, 0.6)',
    activeBgColor: '#fef3c7',
    hoverColor: '#eab308',
    emoji: '😮',
    name: 'Wow',
  },
  sad: {
    activeColor: 'text-purple-600',
    hoverBgColor: '#faf5ff',
    hoverShadow: '0 0 12px rgba(147, 51, 234, 0.6)',
    activeBgColor: '#f3e8ff',
    hoverColor: '#9333ea',
    emoji: '😢',
    name: 'Sad',
  },
  angry: {
    activeColor: 'text-red-600',
    hoverBgColor: '#fef2f2',
    hoverShadow: '0 0 12px rgba(220, 38, 38, 0.6)',
    activeBgColor: '#fee2e2',
    hoverColor: '#dc2626',
    emoji: '😡',
    name: 'Angry',
  },
}

export const communityReactionName: Record<string, string> = {
  like: 'Thích',
  love: 'Yêu thích',
  haha: 'Haha',
  wow: 'Wow',
  sad: 'Buồn',
  angry: 'Giận dữ',
}

export interface ReactionDisplayGroup {
  emojiData?: EmojiData
  reactionType: string
  identifier: string
  count: number
  users: Array<{ id: number; name: string }>
}
